import { SkeletonMesh } from '@esotericsoftware/spine-threejs';
import { MeshProps, useFrame } from '@react-three/fiber';
import { useRef, useEffect } from 'react';


type CharacterProps = {
  mesh?: SkeletonMesh,
  animation?: string,
  loop?: boolean,
  name?: string
} & MeshProps

function Character({mesh, animation, loop, name, ...rest}: CharacterProps) {

  const ref = useRef<SkeletonMesh>(null)

  useFrame((_, delta) => mesh?.update(delta))

  useEffect(() => {
    if(animation && ref.current) {
      //console.log('cur', ref.current)
      //ref.current.state.setEmptyAnimation(0)
      ref.current.state.setAnimation(0, animation, !!loop)
    }
  }, [animation, loop, name])

  if(!mesh) {
    return null
  }

  return <primitive ref={ref} object={mesh} {...rest}/>
}

export default Character